(ns hypnos.translator.organization
  "Translators between Clojure and GraphQL for the organization models."
  (:require [clojure.spec.alpha :as s]
            [clojure.string :as str]
            [medley.core :as mc]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Specs

;; timezone
(def ^{:const true :private true} timezones
  #{:timezone/est
    :timezone/est5edt
    :timezone/cst6cdt
    :timezone/mst
    :timezone/mst7mdt
    :timezone/pst
    :timezone/pst8pdt
    :timezone/akdt
    :timezone/hst})
(s/def ::timezone timezones)
(s/def ::timezone-gql (set (map name timezones)))

;; organization type
(def ^{:const true :private true} types #{:organization-type/dme :organization-type/sleeplab})
(s/def ::type types)
(s/def ::type-gql (set (map name types)))

;; status
(def ^{:const true :private true} statuses #{:status/active :status/inactive})
(s/def ::status statuses)
(s/def ::status-gql (set (map name statuses)))

;; organization

(s/def :organization/id uuid?)
(s/def :organization/key string?)
(s/def :organization/name string?)
(s/def :organization/subdomain string?)
(s/def :organization/timezone ::timezone)
(s/def :organization/type ::type)
(s/def :organization/entities (s/coll-of :hypnos/organization :kind vector? :min-count 1 :max-count 5 :distinct true))
;; (s/def :organization/users (s/coll-of :hypnos/org-users :kind vector? :distinct true))
(s/def :organization/status ::status)

(s/def :organization.gql/id string?)
(s/def :organization.gql/key string?)
(s/def :organization.gql/name string?)
(s/def :organization.gql/subdomain string?)
(s/def :organization.gql/timezone ::timezone-gql)
(s/def :organization.gql/type ::type-gql)
(s/def :organization.gql/entities (s/coll-of :hypnos.gql/organization :kind vector? :min-count 1 :max-count 5 :distinct true))
;; (s/def :organization.gql/users (s/coll-of :hypnos.gql/organization :kind vector? :distinct true))
(s/def :organization.gql/status ::status-gql)

(s/def :hypnos/organization
  (s/keys :req [:organization/id
                :organization/key
                :organization/name
                :organization/subdomain
                :organization/timezone
                :organization/type
                :organization/entities
                ;; :user/_organizations
                :organization/status]))

(s/def :hypnos.gql/manufacturer
  (s/keys :req-un [:organization.gql/id
                   :organization.gql/key
                   :organization.gql/name
                   :organization.gql/subdomain
                   :organization.gql/timezone
                   :organization.gql/type
                   :organization.gql/entities
                   ;; :organization.gql/users
                   :organization.gql/status]))

;; user

(s/def :user/id uuid?)
(s/def :user/key string?)
(s/def :user/email string?)
(s/def :user/first-name string?)
(s/def :user/last-name string?)
(s/def :user/organizations (s/coll-of :hypnos/organization :kind vector? :min-count 1 :max-count 3 :distinct true))
(s/def :user/status ::status)

(s/def :user.gql/id string?)
(s/def :user.gql/key string?)
(s/def :user.gql/email string?)
(s/def :user.gql/first-name string?)
(s/def :user.gql/last-name string?)
(s/def :user.gql/organizations (s/coll-of :hypnos.gql/organization :kind vector? :min-count 1 :max-count 3 :distinct true))
(s/def :user.gql/status ::status-gql)

(s/def :hypnos/org-user
  (s/keys :req [:user/id
                :user/key
                :user/email
                :user/first-name
                :user/last-name
                :user/status]))

(s/def :hypnos.gql/org-user
  (s/keys :req-un [:user.gql/id
                   :user.gql/key
                   :user.gql/email
                   :user.gql/first-name
                   :user.gql/last-name
                   :user.gql/status]))

(s/def :hypnos/user
  (s/keys :req [:user/id
                :user/key
                :user/email
                :user/first-name
                :user/last-name
                :user/organizations
                :user/status]))

(s/def :hypnos.gql/user
  (s/keys :req-un [:user.gql/id
                   :user.gql/key
                   :user.gql/email
                   :user.gql/first-name
                   :user.gql/last-name
                   :user.gql/organizations
                   :user.gql/status]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Enums

(defn timezone->clj
  [s]
  (when-not (str/blank? s)
    (keyword (str "timezone/" s))))

(s/fdef timezone->clj
  :args (s/cat :s (s/or :timezone ::timezone-gql :nil nil?))
  :ret (s/or :timezone ::timezone :nil nil?))

(defn timezone->gql
  [o]
  (when (keyword? o)
    (name o)))

(s/fdef timezone->gql
  :args (s/cat :o (s/or :timezone ::timezone :nil nil?))
  :ret (s/or :timezone ::timezone-gql :nil nil?))


(defn type->clj
  [s]
  (when-not (str/blank? s)
    (keyword (str "organization-type/" s))))

(s/fdef type->clj
  :args (s/cat :s (s/or :type ::type-gql :nil nil?))
  :ret (s/or :type ::type :nil nil?))

(defn type->gql
  [o]
  (when (keyword? o)
    (name o)))

(s/fdef type->gql
  :args (s/cat :o (s/or :type ::type :nil nil?))
  :ret (s/or :type ::type-gql :nil nil?))

(defn status->clj
  [s]
  (when-not (str/blank? s)
    (keyword (str "status/" s))))

(s/fdef status->clj
  :args (s/cat :s (s/or :status ::status-gql :nil nil?))
  :ret (s/or :status ::status :nil nil?))

(defn status->gql
  [o]
  (when (keyword? o)
    (name o)))

(s/fdef status->gql
  :args (s/cat :o (s/or :status ::status :nil nil?))
  :ret (s/or :status ::status-gql :nil nil?))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Entities

(declare org-user->clj org-user->gql)

;; Organization, User

(defn organization->clj
  "Convert the organization to the Clojure format."
  [m]
  (cond-> {}
    (:id m)        (assoc :organization/id (mc/uuid (:id m)))
    (:key m)       (assoc :organization/key (:key m))
    (:name m)      (assoc :organization/name (:name m))
    (:subdomain m) (assoc :organization/subdomain (:subdomain m))
    (:timezone m)  (assoc :organization/timezone (timezone->clj (:timezone m)))
    (:type m)      (assoc :organization/type (type->clj (:type m)))
    (:entities m)  (assoc :organization/entities (mapv organization->clj (:entities m)))
    (:users m)     (assoc :user/_organizations (mapv org-user->clj (:users m)))
    (:status m)    (assoc :organization/status (status->clj (:status m)))))

(s/fdef organization->clj
  :args (s/cat :m :hypnos.gql/organization)
  :ret (s/and map? :hypnos/organization))

(defn organization->gql
  "Convert the organization to the GraphQL format."
  [m]
  (cond-> {}
    (:organization/id m)        (assoc :id (str (:organization/id m)))
    (:organization/key m)       (assoc :key (:organization/key m))
    (:organization/name m)      (assoc :name (:organization/name m))
    (:organization/subdomain m) (assoc :subdomain (:organization/subdomain m))
    (:organization/timezone m)  (assoc :timezone (timezone->gql (:organization/timezone m)))
    (:organization/type m)      (assoc :type (timezone->gql (:organization/type m)))
    (:organization/entities m)  (assoc :entities (mapv organization->gql (:organization/entities m)))
    (:user/_organizations m)    (assoc :users (mapv org-user->gql (:user/_organizations m)))
    (:organization/status m)    (assoc :status (status->gql (:organization/status m)))))

(s/fdef organization->gql
  :args (s/cat :m :hypnos/organization)
  :ret (s/and map? :hypnos.gql/organization))

(defn org-user->clj
  "Convert the organization user to the Clojure format."
  [m]
  (cond-> {}
    (:id m)         (assoc :user/id (mc/uuid (:id m)))
    (:key m)        (assoc :user/key (mc/uuid (:key m)))
    (:email m)      (assoc :user/email (:email m))
    (:first_name m) (assoc :user/first-name (:first_name m))
    (:last_name m)  (assoc :user/last-name (:last_name m))
    (:status m)     (assoc :user/status (status->clj (:status m)))))

(s/fdef org-user->clj
  :args (s/cat :m :hypnos.gql/org-user)
  :ret (s/and map? :hypnos/org-user))

(defn org-user->gql
  "Convert the organization user to the GraphQL format."
  [m]
  (cond-> {}
    (:user/id m)            (assoc :id (str (:user/id m)))
    (:user/key m)           (assoc :key (str (:user/key m)))
    (:user/email m)         (assoc :email (:user/email m))
    (:user/first-name m)    (assoc :first_name (:user/first-name m))
    (:user/last-name m)     (assoc :last_name (:user/last-name m))
    (:user/status m)        (assoc :status (status->gql (:user/status m)))))

(s/fdef org-user->gql
  :args (s/cat :m :hypnos/org-user)
  :ret (s/and map? :hypnos.gql/org-user))

(defn user->clj
  "Convert the user to the Clojure format."
  [m]
  (cond-> {}
    (:id m)            (assoc :user/id (mc/uuid (:id m)))
    (:key m)           (assoc :user/key (mc/uuid (:key m)))
    (:organizations m) (assoc :user/organizations (mapv organization->clj (:organizations m)))
    (:email m)         (assoc :user/email (:email m))
    (:first_name m)    (assoc :user/first-name (:first_name m))
    (:last_name m)     (assoc :user/last-name (:last_name m))
    (:status m)        (assoc :user/status (status->clj (:status m)))))

(s/fdef user->clj
  :args (s/cat :m :hypnos.gql/user)
  :ret (s/and map? :hypnos/user))

(defn user->gql
  "Convert the user to the GraphQL format."
  [m]
  (cond-> {}
    (:user/id m)            (assoc :id (str (:user/id m)))
    (:user/key m)           (assoc :key (str (:user/key m)))
    (:user/organizations m) (assoc :organizations (mapv organization->gql (:user/organizations m)))
    (:user/email m)         (assoc :email (:user/email m))
    (:user/first-name m)    (assoc :first_name (:user/first-name m))
    (:user/last-name m)     (assoc :last_name (:user/last-name m))
    (:user/status m)        (assoc :status (status->gql (:user/status m)))))

(s/fdef user->gql
  :args (s/cat :m :hypnos/user)
  :ret (s/and map? :hypnos.gql/user))
